export class Frequency {
    
    public id: string;
    public activity_id: string;
    public activity_name: string;   
    public day_id: string;
    public day_name: string;  
    public event_id: string;
    public event_name: string;  
    public member_id: string;
    public member_name: string;  
    public member_category_id: string;
    public member_category_name: string;  
    public topic_id: string;
    public topic_name: string;  
    public type: string;   
    public date: Date;   
    
    constructor() {}
}

